import { createSlice } from '@reduxjs/toolkit';

interface StockPreviewState {
	previewMode: 'inventory_material' | 'vendor_material';
	orderLineItem: string | null;
	materialCutLength: number;
	materialSawKerf: number;
	materialCutQuantity: number;
	materialStockFacingAmount: number;
	requiredMaterialLength: number;
	vendorMaterialCutLength: number;
	vendorMaterialSawKerf: number;
	vendorMaterialCutQuantity: number;
	vendorMaterialStockFacingAmount: number;
	requiredVendorMaterialLength: number;
}

const initialState: StockPreviewState = {
	previewMode: 'inventory_material',
	orderLineItem: null,
	materialCutLength: 0,
	materialSawKerf: 0.07,
	materialCutQuantity: 1,
	materialStockFacingAmount: 0.03,
	requiredMaterialLength: 0,
	vendorMaterialCutLength: 0,
	vendorMaterialSawKerf: 0.07,
	vendorMaterialCutQuantity: 1,
	vendorMaterialStockFacingAmount: 0.03,
	requiredVendorMaterialLength: 0,
};

function round(value: number) {
	return Number(value.toFixed(2));
}

export const stockPreview = createSlice({
	name: 'stockPreview',
	initialState,
	reducers: {
		setPreviewMode: (state, action) => {
			state.previewMode = action.payload;
		},
		setOrderLineItem: (state, action) => {
			state.orderLineItem = action.payload;
		},
		setMaterialCutLength: (state, action) => {
			state.materialCutLength = Number(action.payload);
			state.requiredMaterialLength = round(
				(Number(action.payload) + state.materialSawKerf) *
					state.materialCutQuantity
			);
		},
		setMaterialSawKerf: (state, action) => {
			state.materialSawKerf = Number(action.payload);
			state.requiredMaterialLength = round(
				(state.materialCutLength + Number(action.payload)) *
					state.materialCutQuantity
			);
		},
		setMaterialCutQuantity: (state, action) => {
			state.materialCutQuantity = Number(action.payload);
			state.requiredMaterialLength = round(
				(state.materialCutLength + state.materialSawKerf) *
					Number(action.payload)
			);
		},
		setMaterialStockFacingAmount: (state, action) => {
			state.materialStockFacingAmount = Number(action.payload);
		},
		setVendorMaterialCutLength: (state, action) => {
			state.vendorMaterialCutLength = Number(action.payload);
			state.requiredVendorMaterialLength = round(
				(Number(action.payload) + state.vendorMaterialSawKerf) *
					state.vendorMaterialCutQuantity
			);
		},
		setVendorMaterialSawKerf: (state, action) => {
			state.vendorMaterialSawKerf = Number(action.payload);
			state.requiredVendorMaterialLength = round(
				(state.vendorMaterialCutLength + Number(action.payload)) *
					state.vendorMaterialCutQuantity
			);
		},
		setVendorMaterialCutQuantity: (state, action) => {
			state.vendorMaterialCutQuantity = Number(action.payload);
			state.requiredVendorMaterialLength = round(
				(state.vendorMaterialCutLength + state.vendorMaterialSawKerf) *
					Number(action.payload)
			);
		},
		setVendorMaterialStockFacingAmount: (state, action) => {
			state.vendorMaterialStockFacingAmount = Number(action.payload);
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	setPreviewMode,
	setOrderLineItem,
	setMaterialCutLength,
	setMaterialCutQuantity,
	setMaterialSawKerf,
	setMaterialStockFacingAmount,
	setVendorMaterialCutLength,
	setVendorMaterialCutQuantity,
	setVendorMaterialSawKerf,
	setVendorMaterialStockFacingAmount,
} = stockPreview.actions;

export default stockPreview.reducer;
